const FLAGS = [
  { name: "United States", file: "067-united states.svg" },
  { name: "United Kingdom", file: "034-united kingdom.svg" },
  { name: "Germany", file: "131-germany.svg" },
  { name: "Spain", file: "165-spain.svg" },
  { name: "France", file: "098-france.svg" },
  { name: "Italy", file: "260-italy.svg" },
  { name: "China", file: "247-china.svg" },
  { name: "Japan", file: "226-japan.svg" },
  { name: "Canada", file: "017-canada.svg" },
  { name: "Australia", file: "026-australia.svg" },
  { name: "Ireland", file: "081-ireland.svg" },
  { name: "South Korea", file: "199-south korea.svg" },
  { name: "Brazil", file: "005-brazil.svg" },
  { name: "Portugal", file: "036-portugal.svg" },
  { name: "Mexico", file: "008-mexico.svg" },
  { name: "Argentina", file: "062-argentina.svg" },
  { name: "Netherlands", file: "023-netherlands.svg" },
  { name: "Switzerland", file: "055-switzerland.svg" },
  { name: "Belgium", file: "095-belgium.svg" },
  { name: "Austria", file: "257-austria.svg" },
  { name: "Russia", file: "012-russia.svg" },
  { name: "India", file: "014-india.svg" },
  { name: "Turkey", file: "042-turkey.svg" },
  { name: "Sweden", file: "076-sweden.svg" },
  { name: "Norway", file: "117-norway.svg" },
  { name: "Denmark", file: "086-denmark.svg" },
  { name: "Poland", file: "049-poland.svg" },
  { name: "Ukraine", file: "115-ukraine.svg" },
  { name: "Greece", file: "090-greece.svg" },
  { name: "Czech Republic", file: "111-czech republic.svg" },
  { name: "United Arab Emirates", file: "109-united arab emirates.svg" },
  { name: "Saudi Arabia", file: "127-saudi arabia.svg" },
  { name: "Egypt", file: "102-egypt.svg" },
  { name: "Morocco", file: "094-morocco.svg" },
  { name: "Israel", file: "105-israel.svg" },
  { name: "Vietnam", file: "040-vietnam.svg" },
  { name: "Thailand", file: "022-thailand.svg" },
  { name: "Indonesia", file: "051-indonesia.svg" },
  { name: "Philippines", file: "068-philippines.svg" },
  { name: "Malaysia", file: "142-malasya.svg" },
  { name: "Hungary", file: "145-hungary.svg" },
  { name: "Romania", file: "151-romania.svg" },
  { name: "Bulgaria", file: "092-bulgaria.svg" },
  { name: "Finland", file: "135-finland.svg" },
  { name: "Iceland", file: "180-iceland.svg" },
  { name: "Chile", file: "129-chile.svg" },
  { name: "Colombia", file: "083-colombia.svg" },
  { name: "Peru", file: "072-peru.svg" },
  { name: "South Africa", file: "060-south africa.svg" },
  { name: "Nigeria", file: "174-nigeria.svg" },
];

const LanguagesGrid = () => {
  // A slow marquee, so every flag passes by on any screen (#1394). The list is drawn
  // twice and the track slides by half its width, which loops with no jump; the
  // second copy is decoration for assistive tech (alt="", aria-hidden). It pauses
  // while hovered or touched. With "reduce motion" nothing moves and the strip is a
  // plain horizontal scroller instead (same fade at the edges, no scrollbar).
  return (
    <section className="py-16 bg-background overflow-hidden border-y border-border">
      <div
        data-testid="flag-strip"
        data-marquee
        className="group overflow-hidden motion-reduce:overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden [mask-image:linear-gradient(to_right,transparent,#000_8%,#000_92%,transparent)]"
      >
        <div
          data-testid="flag-track"
          className="ml-10 flex w-max items-center gap-10 pr-10 whitespace-nowrap flex-nowrap animate-flag-marquee group-hover:[animation-play-state:paused] group-active:[animation-play-state:paused] motion-reduce:animate-none"
        >
          {[0, 1].map((copy) =>
            FLAGS.map((flag) => (
              <img
                key={`${copy}-${flag.name}`}
                src={`/images/homepage/flags/${flag.file}`}
                alt={copy === 0 ? flag.name : ""}
                aria-hidden={copy === 0 ? undefined : true}
                className="w-12 h-12 md:w-14 md:h-14 shrink-0"
              />
            )),
          )}
        </div>
      </div>
    </section>
  );
};

export default LanguagesGrid;
